import { GET_RECORDS, GET_RECORDS_ERROR } from "../actions/types";

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_RECORDS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_RECORDS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
